import { graphql, useStaticQuery } from 'gatsby';
import { MenuItemType, MenuType } from '../types';

export function getHeaderMenu(): Array<MenuType> | undefined {
  const data = useStaticQuery(graphql`
    query HeaderQuery {
      allSanityHeaderMenu(filter: { _id: { eq: "headerMenu" } }) {
        nodes {
          _id
          subMenus {
            ...MenuFragment
          }
        }
      }
    }
  `);

  const headerMenuDoc = data.allSanityHeaderMenu.nodes[0];
  const menus = getMenusFromHeaderMenuDoc(headerMenuDoc);

  if (!menus) {
    console.error('No menus found in header menu document');
    return undefined;
  }

  return menus;
}

function isMenuItem(item: any): item is MenuItemType {
  return (
    typeof item === 'object' &&
    item !== null &&
    '_type' in item &&
    item._type === 'menuItem' &&
    'title' in item &&
    typeof item.title === 'object' &&
    'link' in item &&
    typeof item.link === 'string'
  );
}

function getMenusFromHeaderMenuDoc(headerMenu: any): MenuType[] | undefined {
  if (!headerMenu || !headerMenu.subMenus) {
    console.error('Header menu document is missing or has no subMenus');
    return undefined;
  }

  const menus = headerMenu.subMenus;

  if (!Array.isArray(menus)) {
    console.error('Expected subMenus to be an array');
    return undefined;
  }

  return menus.map((menu) => {
    return {
      _key: menu._key,
      _type: menu._type,
      menuItems: (menu.menuItems = menu.menuItems.filter(isMenuItem)),
      title: menu.title,
    };
  });
}

export const MenuFragment = graphql`
  fragment MenuFragment on SanityMenu {
    _key
    _type
    title {
      nb
      nn
      en
    }
    menuItems {
      ...MenuItemFragment
    }
  }
`;

export const MenuItemFragment = graphql`
  fragment MenuItemFragment on SanityMenuItem {
    _key
    _type
    title {
      nb
      nn
      en
    }
    link
  }
`;
